export function getBaseUrl(): string {
	return String(process.env.NEXT_PUBLIC_BASE_URL).replace(/\/$/, '')
}
